const BANK_CREDENTIAL_ATTRIBUTE = 'data-bank-credential';

export const BANK_CREDENTIAL_PRIVACY = Object.freeze({
  selector: `[${BANK_CREDENTIAL_ATTRIBUTE}]`,
  domProps: Object.freeze({ [BANK_CREDENTIAL_ATTRIBUTE]: true }),
});
